import { EuiButtonEmpty, EuiButtonProps } from "@inscopix/ideas-eui";
import ModalCreateProject from "components/ModalProject/ModalCreateProject";
import { Tooltip } from "components/Tooltip/Tooltip";
import { Tenant } from "graphql/_Types";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { useState } from "react";

interface ButtonCreateProjectProps extends Omit<EuiButtonProps, "onClick"> {
  tenantId?: Tenant["id"];
}

export const ButtonCreateProject = ({
  tenantId,
  ...buttonProps
}: ButtonCreateProjectProps) => {
  const hasInternalSpaceOrTenant = useUserContext(
    (s) =>
      (s.personalSpace !== undefined && !s.personalSpace.isExternal) ||
      s.tenants.length > 0,
  );
  const [showModalCreateProject, setShowModalCreateProject] = useState(false);

  return (
    <>
      <Tooltip
        content={
          hasInternalSpaceOrTenant
            ? ""
            : "You do not have any organizations in this region you can create a project in"
        }
      >
        <EuiButtonEmpty
          color="primary"
          iconType={"plus"}
          {...buttonProps}
          onClick={() => setShowModalCreateProject(true)}
          disabled={!hasInternalSpaceOrTenant}
        >
          Create Project
        </EuiButtonEmpty>
      </Tooltip>

      {showModalCreateProject && (
        <ModalCreateProject
          tenantId={tenantId}
          onClose={() => setShowModalCreateProject(false)}
        />
      )}
    </>
  );
};
